import React from 'react';
import icon from "../../assets/icons/instagramIcon.svg";

export default () => <img width={20} src={icon}/>;
